import ExaminationAssignment from "./ExaminationAssignment";

export default ExaminationAssignment;
